import { withStyles, Box, Icon } from 'vopay';
import styles from './TicketsPage.module.scss';
import { Tab } from './TicketsPage';
import { useTranslation } from 'react-i18next';
import { Title } from 'UI';

const cn = withStyles(styles);

type EmptyOrNoResultsProps = {
  activeTab: Tab;
};

const EmptyOrNoResults = ({ activeTab }: EmptyOrNoResultsProps) => {
  const { t } = useTranslation('translations', { keyPrefix: 'TicketsList.EmptyState' });
  const title = activeTab === 'active' ? t('titleNoActive') : t('titleNoClosed');
  const description = activeTab === 'active' ? t('descriptionNoActive') : t('descriptionNoClosed');

  return (
    <Box flx="col" className={cn('ticketListTableContainer')} width="100%" gap="common">
      <Box flx="col" jc="center" gap="sm">
        <Box ai="center" jc="center" height="auto">
          <Icon icon="photo" size="xxlg" color="greyLight" />
        </Box>
        <Box ai="center" jc="center" pt="md" height="auto">
          <Title level="3">{title}</Title>
        </Box>

        <Box ai="center" jc="center" height="auto" className={cn('emptyListDescription')}>
          {description}
        </Box>
      </Box>
    </Box>
  );
};

export default EmptyOrNoResults;
